import { useRouter } from "next/router"
import SectionGallery from "@components/global/SectionGallery"
import LocationDetailConcession from "@components/pages/locations/location-detail-concession"
import LocationDetailCover from "@components/pages/locations/location-detail-cover"
import LocationDetailMaps from "@components/pages/locations/location-detail-maps"
import LocationDetailMovies from "@components/pages/locations/location-detail-movies"
import LocationDetailTheaters from "@components/pages/locations/location-detail-theaters"
import { getOutletDetail } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { convertJson, extractMeta, imgUrl } from "src/mixins"

function LocationDetail({ data }) {
  // const baseImgPath = process.env.STORAGE_URL
  const Router = useRouter()
  const { locale } = Router
  const hero = extractMeta(data?.meta, "hero")
  const gallery = extractMeta(data?.meta, "gallery")
  const maps = extractMeta(data?.meta, "google_maps")
  const nowPlaying = data?.nowplaying?.reduce(
    (obj, item) =>
      Object.assign(obj, {
        [item.option_name.split(".")[1]]: item.option_value,
      }),
    {}
  )
  const nowPlayingUrl = extractMeta(data?.meta, "now_playing")?.url
  return (
    <>
      <LocationDetailCover
        title={data?.[`title_${locale}`]}
        text=""
        img={imgUrl(hero?.banner_image_mobile)}
        imgMd={imgUrl(hero?.banner_image_desktop)}
        locale={locale}
      />
      <LocationDetailMaps
        locale={locale}
        data={{
          ...data,
          phone: extractMeta(data?.meta, "contact")?.phone,
          maps,
        }}
      />
      {data?.cinemas?.length ? (
        <LocationDetailTheaters locale={locale} cinemas={data?.cinemas} />
      ) : null}
      {data?.concessions?.length ? (
        <LocationDetailConcession
          locale={locale}
          concessions={data?.concessions}
        />
      ) : null}
      {convertJson(gallery?.items)?.length ? (
        <SectionGallery
          sectionName="sc-location-detail-gallery"
          data={convertJson(gallery.items)}
        />
      ) : null}
      <LocationDetailMovies
        data={nowPlaying}
        url={nowPlayingUrl}
        locale={locale}
      />
    </>
  )
}
export default LocationDetail

export const getServerSideProps = async (ctx) => {
  ctx.res.setHeader(
    "Cache-Control",
    "public, s-maxage=43200, stale-while-revalidate=60"
  )
  const { locale, query } = ctx
  const { slug } = query
  const data = await getOutletDetail(slug)
  if (data) {
    return {
      props: {
        data,
        seo: {
          title: data[`title_${locale}`],
          description:
            locale === "en"
              ? metaDesc.outlet_en(data?.title_en)
              : metaDesc.outlet_id(data?.title_id),
        },
        page: "location-detail",
      },
    }
  }
  return { notFound: true }
}

// export async function getStaticPaths() {
//   const routesId = ["arion", "artha-gading", "atrium"]?.map((item) => ({
//     params: { slug: item },
//     locale: "id",
//   }))
//   const routesEn = ["arion", "artha-gading", "atrium"]?.map((item) => ({
//     params: { slug: item },
//     locale: "en",
//   }))
//   return { paths: [...routesEn, ...routesId], fallback: false }
// }

// export async function getStaticProps(ctx) {
//   const { slug } = ctx.params
//   // const data = await getOutletDetail(slug)
//   return {
//     props: {
//       seo: {
//         title: "Check",
//       },
//       page: "location-detail",
//     },
//     revalidate: 60,
//   }
// }
